const MAX_DAYS_IN_MONTH = 31;
const MAX_YEARS_LIMIT = 90;
const MAX_AVAILABILITY_YEARS = 10;

const getDayOptions = (maxOffset) => {
  return Array.from(new Array(maxOffset), (val, index) => {
    return {
      label: (index + 1).toString(),
      value: index + 1,
    };
  });
};

/**
 * Get an array of years up until now
 *
 * @param {number} maxOffset - number of years previous to this year
 * @returns {Array<{ label: string, value: number }>}
 */
const getPastYearOptions = (maxOffset) => {
  const currentYear = new Date().getFullYear();
  return Array.from(new Array(maxOffset), (val, index) => {
    const year = currentYear - index;
    return {
      label: year.toString(),
      value: year,
    };
  });
};

const getFutureYearOptions = (maxOffset) => {
  const currentYear = new Date().getFullYear();
  return Array.from(new Array(maxOffset), (val, index) => {
    const year = currentYear + index;
    return {
      label: year,
      value: year,
    };
  });
};

export const titleOptions = [
  { label: "", value: "" },
  { label: "Mr", value: "Mr" },
  { label: "Mrs", value: "Mrs" },
  { label: "Miss", value: "Miss" },
  { label: "Dr", value: "Dr" },
];

export const monthOptions = [
  { label: "Month", value: "" },
  { label: "January", value: 0 },
  { label: "February", value: 1 },
  { label: "March", value: 2 },
  { label: "April", value: 3 },
  { label: "May", value: 4 },
  { label: "June", value: 5 },
  { label: "July", value: 6 },
  { label: "August", value: 7 },
  { label: "September", value: 8 },
  { label: "October", value: 9 },
  { label: "November", value: 10 },
  { label: "December", value: 11 },
];

export const dayOptions = [
  { label: "Day", value: "" },
  ...getDayOptions(MAX_DAYS_IN_MONTH),
];

export const yearOptions = [
  { label: "Year", value: "" },
  ...getPastYearOptions(MAX_YEARS_LIMIT),
];

export const salaryFrequencyOptions = [
  { label: "Per Annum", value: "A" },
  { label: "Per Month", value: "M" },
  { label: "Per Week", value: "W" },
  { label: "Per Day", value: "D" },
  { label: "Per Hour", value: "H" },
];

export const availabilityYearOptions = [
  { label: "Year", value: "" },
  ...getFutureYearOptions(MAX_AVAILABILITY_YEARS),
];

export const countriesOptions = [
  { label: "United Kingdom", value: "UK" },
  { label: "Argentina", value: "ARGE" },
  { label: "Australia", value: "AUS" },
  { label: "Austria", value: "AUST" },
  { label: "Azerbaijan ", value: "AZA" },
  { label: "Belgium", value: "BEL" },
  { label: "Brazil", value: "BRAZ" },
  { label: "Bulgaria", value: "BULG" },
  { label: "Camaroon", value: "CAM" },
  { label: "Canada", value: "CANA" },
  { label: "China", value: "CHIN" },
  { label: "Colombia", value: "COLM" },
  { label: "Denmark", value: "DENM" },
  { label: "Egypt", value: "EGYP" },
  { label: "Republic of Ireland", value: "EIRE" },
  { label: "England", value: "ENGL" },
  { label: "Estonia", value: "ESTO" },
  { label: "Netherlands", value: "FA" },
  { label: "Finland", value: "FIN" },
  { label: "France", value: "FRAN" },
  { label: "Germany", value: "GERM" },
  { label: "Greece", value: "GRE" },
  { label: "Hong Kong", value: "HONK" },
  { label: "Hungary", value: "HUNG" },
  { label: "Ivory Coast ", value: "IC" },
  { label: "Indonesia", value: "IND2" },
  { label: "India", value: "INDI" },
  { label: "Ireland", value: "IREL" },
  { label: "Italy", value: "ITAL" },
  { label: "Japan", value: "JAP" },
  { label: "Latvia", value: "LATV" },
  { label: "New Zealand", value: "M" },
  { label: "Malaysia", value: "MALA" },
  { label: "Mexico", value: "MEXA" },
  { label: "Nigeria", value: "NIGE" },
  { label: "Northern Ireland", value: "NIR" },
  { label: "Norway", value: "NOR" },
  { label: "Singapore", value: "O" },
  { label: "Pakistan", value: "PAKI" },
  { label: "Peru", value: "PERU" },
  { label: "Philippines", value: "PHIL" },
  { label: "Poland", value: "POLA" },
  { label: "Portugal", value: "PORT" },
  { label: "Romania", value: "ROMA" },
  { label: "Russia", value: "RU" },
  { label: "Saudi Arabia", value: "SAUD" },
  { label: "Scotland", value: "SCOT" },
  { label: "Slovakia", value: "SLOR" },
  { label: "Spain", value: "SPAI" },
  { label: "Sudan", value: "SUDA" },
  { label: "Sweden", value: "SWE" },
  { label: "Switzerland", value: "SWIT" },
  { label: "Syria", value: "SYRI" },
  { label: "Thailand", value: "THA" },
  { label: "Turkey", value: "TURK" },
  { label: "United Arab Emirates", value: "UAE" },
  { label: "Ukraine", value: "UKRA" },
  { label: "Uruguay", value: "URUG" },
  { label: "United States of America", value: "USA" },
  { label: "Venezula", value: "VEN1" },
  { label: "Wales", value: "WALE" },
  { label: "Yemenis", value: "YEM" },
  { label: "Yemen", value: "YEME" },
];

export const nationalitiesOptions = [
  { label: "British", value: "A" },
  { label: "Afghan", value: "AFG" },
  { label: "Albanian", value: "ALB" },
  { label: "Algerian", value: "AL" },
  { label: "American", value: "B" },
  { label: "Andorran", value: "AND" },
  { label: "Angolan", value: "ANG" },
  { label: "Argentinean", value: "ARG" },
  { label: "Armenian", value: "ARM" },
  { label: "Australian", value: "AUZT" },
  { label: "Austrian", value: "AUTR" },
  { label: "Azerbaijani", value: "AZA" },
  { label: "Bahamian", value: "BAH" },
  { label: "Bahraini", value: "BAHR" },
  { label: "Bangladeshi", value: "BANG" },
  { label: "Barbadian", value: "BRB" },
  { label: "Belarusian", value: "BELA" },
  { label: "Belgian", value: "BEL" },
  { label: "Belizean", value: "BELI" },
  { label: "Bermudian", value: "BERM" },
  { label: "Bolivian", value: "BOL" },
  { label: "Bosnian", value: "BOSN" },
  { label: "Brazilian", value: "BRA" },
  { label: "Bruneian", value: "BRN" },
  { label: "Bulgarian", value: "Z" },
  { label: "Burundian", value: "BURU" },
  { label: "Cameroonian", value: "CAM" },
  { label: "Cambodian", value: "CAMB" },
  { label: "Canadian", value: "H" },
  { label: "Chadian", value: "CHAD" },
  { label: "Chilean", value: "CHIL" },
  { label: "Chinese", value: "W" },
  { label: "Colombian", value: "COLO" },
  { label: "Comoran", value: "COMO" },
  { label: "Congolese", value: "CONG" },
  { label: "Croatian", value: "CRO" },
  { label: "Cuban", value: "CUBA" },
  { label: "Cypriot", value: "CYPR" },
  { label: "Czech", value: "X" },
  { label: "Danish", value: "DANE" },
  { label: "Dominican", value: "DOMI" },
  { label: "Dutch", value: "DU" },
  { label: "Ecuadorean", value: "ECUA" },
  { label: "Egyptian", value: "EG" },
  { label: "Emirati", value: "EMIR" },
  { label: "Eritrean", value: "EN" },
  { label: "Estonian", value: "RA" },
  { label: "Ethiopian", value: "ETHI" },
  { label: "Fijian", value: "FIJI" },
  { label: "Filipino", value: "FIL" },
  { label: "Finnish", value: "FINL" },
  { label: "French", value: "E" },
  { label: "Gambian", value: "GAM" },
  { label: "Georgian", value: "GEOR" },
  { label: "German", value: "F" },
  { label: "Ghanian", value: "GA" },
  { label: "Greek", value: "GREE" },
  { label: "Grenadian", value: "GREN" },
  { label: "Guyanese", value: "GUYA" },
  { label: "Haitian", value: "HAIT" },
  { label: "Honduran", value: "HOND" },
  { label: "Hong Konger", value: "HONK" },
  { label: "Hungarian", value: "HUN1" },
  { label: "Icelandic", value: "ICE" },
  { label: "Indian", value: "J" },
  { label: "Indonesian", value: "INDO" },
  { label: "Iranian", value: "Y" },
  { label: "Iraqi", value: "IR" },
  { label: "Irish", value: "EIRE" },
  { label: "Israeli", value: "ISRA" },
  { label: "Italian", value: "IT" },
  { label: "Ivorian", value: "IC" },
  { label: "Jamaican", value: "JA" },
  { label: "Japanese", value: "G" },
  { label: "Jordanian", value: "JORD" },
  { label: "Kenyan ", value: "KEN" },
  { label: "Korean", value: "KORE" },
  { label: "Kosovan", value: "KOSO" },
  { label: "Kuwaiti", value: "KUWA" },
  { label: "Latvian", value: "Q" },
  { label: "Lebanese", value: "LEBA" },
  { label: "Liberian", value: "LIBE" },
  { label: "Libyan", value: "LIBY" },
  { label: "Liechtenstein", value: "LEIC" },
  { label: "Lithuanian", value: "LIT" },
  { label: "Luxembourger", value: "LUXE" },
  { label: "Macedonian", value: "MAC" },
  { label: "Malaysian", value: "MAL" },
  { label: "Maltese", value: "MALT" },
  { label: "Mauritian", value: "MAU" },
  { label: "Mexican", value: "MEXI" },
  { label: "Moldovan", value: "MOL" },
  { label: "Mongolian", value: "MONG" },
  { label: "Montenegrin", value: "MONT" },
  { label: "Moroccan", value: "MORO" },
  { label: "Namibian", value: "NAMB" },
  { label: "Nepalese", value: "NEP" },
  { label: "New Zealander", value: "NZEL" },
  { label: "Nicaraguan", value: "NICA" },
  { label: "Nigerian", value: "P" },
  { label: "Nigerien", value: "PA" },
  { label: "Northern Irish", value: "NIR" },
  { label: "Norwegian", value: "NORW" },
  { label: "Pakistani", value: "PAK" },
  { label: "Palestinian", value: "PALE" },
  { label: "Panamanian", value: "PANA" },
  { label: "Paraguayan", value: "PARA" },
  { label: "Peruvian", value: "PER" },
  { label: "Polish", value: "S" },
  { label: "Portuguese", value: "POR" },
  { label: "Puerto Rican", value: "PUER" },
  { label: "Romanian", value: "T" },
  { label: "Russian", value: "I" },
  { label: "Rwandan", value: "RWAN" },
  { label: "Salvadoran", value: "SALV" },
  { label: "Saudi Arabian", value: "SAU" },
  { label: "Scottish", value: "IA" },
  { label: "Senegalese", value: "SENE" },
  { label: "Serbian", value: "SERB" },
  { label: "Sierra Leonean", value: "SIE" },
  { label: "Slovak", value: "R" },
  { label: "Slovenian", value: "SLOV" },
  { label: "Somali", value: "SO" },
  { label: "South African", value: "SOUT" },
  { label: "Spanish", value: "K" },
  { label: "Sri Lankan", value: "SRI" },
  { label: "Sryian", value: "SRY" },
  { label: "St Lucian", value: "STLU" },
  { label: "Sudanese", value: "SUDE" },
  { label: "Swedish", value: "SW" },
  { label: "Swiss", value: "SWIS" },
  { label: "Taiwanese", value: "TAIW" },
  { label: "Tanzanian", value: "TANZ" },
  { label: "Thai", value: "THAI" },
  { label: "Togolese", value: "TO" },
  { label: "Trinidadian", value: "TRIN" },
  { label: "Tunisian", value: "TUN" },
  { label: "Turkish", value: "TU" },
  { label: "Ugandan", value: "UGAN" },
  { label: "Ukrainian", value: "UKR" },
  { label: "Uzbek", value: "UZBE" },
  { label: "Venezuelan", value: "VEN" },
  { label: "Vietnamese", value: "VIET" },
  { label: "Yemeni", value: "YEM" },
  { label: "Zambian", value: "ZAMB" },
  { label: "Zimbabwean", value: "ZI" },
];

export const sourceOptions = [
  { label: "Adzuna", value: "ADZ" },
  { label: "City Jobs", value: "CITY" },
  { label: "CV Library", value: "CVL" },
  { label: "Drop In", value: "DI" },
  { label: "Facebook", value: "FAC" },
  { label: "Indeed", value: "IND" },
  { label: "Job Centre", value: "JC" },
  { label: "Jobs in Kent", value: "JIK" },
  { label: "Jobsite", value: "JO" },
  { label: "Just Engineers", value: "JUS" },
  { label: "LinkedIn", value: "LIK" },
  { label: "Recommended", value: "REC" },
  { label: "Reed.co.uk", value: "REE1" },
  { label: "Returner", value: "RET" },
  { label: "Total Jobs", value: "TO" },
  { label: "HRGO Website", value: "WEB" },
];

export const livingOnThisAddressOptions = [
  { label: "", value: "" },
  { label: "More than 5 Years", value: "More than 5 Years" },
  { label: "Less than 5 Years", value: "Less than 5 Years" },
];

export const genderOptions = [
  { label: "Female", value: "female" },
  { label: "Male", value: "male" },
];
